import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import {
    get_admin_application_list_action,
} from "../../../actions/adminModule_action/adminModule_action";
import { applicationStatusActionId, award_event_id, awardCategoryActionId, responseError, scoringRoundActionId, user_id } from "../../../utils/constants";
import Pagination from "../../../utils/pagination";
import moment from "moment";
import Header from "../../../common_components/Header";
import { fill_action } from "../../../actions/common_action/fillList_action";
import Footer from "../../../common_components/Footer";
import { data } from "jquery";
import MobileHeader from "../../../common_components/mobileHeader";
const customStepperStyles = {
    pageHeader: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderRadius: '8px',
    },
    headerContent: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    }, category: {
        color: '#F1C841',
        margin: 0,
    },
    applicationInfo: {
        margin: 0,
        fontWeight: 'bold',
    },
    progressContainer: {
        display: 'flex',
        alignItems: 'top',
        justifyContent: 'space-between',
    },
    progressStep: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
    },
};
class AdminApplicationList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            user_id: "", round_name: '', award_name: '', status_name: '',
            applicationData: [], applicationCount: [],
            filteredData: [],
            applicationStatusFillList: [],
            awardProfileFillList: [],
            roundFillList: [],
            isAccordionExpanded: false,
            currentPage: 1,
            round_id: null, award_event_profile_id: null, application_status_id: null,
            dashboardCountType: '', application_no: '',
            sortKey: "applicant_name",
            sortOrder: "asc",
        };
        this.navigateApplication = this.navigateApplication.bind(this);
        this.getApplicationData = this.getApplicationData.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.updateItem = this.updateItem.bind(this);
    }
    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
            setTimeout(() => {
                this.props.navigate("/login");
            }, 500);
        }

        setTimeout(() => {
            {
                sessionStorage.getItem("role_id") == 2 ? (
                    this.props.navigate("/login")
                ) : <></>
            }
        }, 10);
        this.setState({ user_id: user_id });
        this.getFillList(awardCategoryActionId, '', '', award_event_id)
        this.getFillList(applicationStatusActionId, '', '', '')
        this.getFillList(scoringRoundActionId, '', '', '')
        if (this.props.location.state != null) {
            this.setState({
                award_event_profile_id: this.props.location.state?.award_event_profile_id,
                award_name: this.props.location.state?.award_name,
                application_status_id: this.props.location.state?.dashboardCountType,
                status_name: this.props.location.state?.status_name
            })
        }
        setTimeout(() => {
            this.getApplicationData();
        }, 500);
    }
    getFillList(value, user_id, keyword, keyvalue) {
        this.setState({ isLoading: true });
        this.props
            .fill_action(
                value,
                user_id == "" || user_id == null ? null : user_id,
                keyword != "" ? keyword : null,
                keyvalue != "" ? keyvalue : null
            )
            .then((data) => {
                if (data.error != 1) {
                    if (value == awardCategoryActionId) {
                        this.setState({
                            awardProfileFillList: data.data,
                        });
                    }
                    if (value == applicationStatusActionId) {
                        this.setState({
                            applicationStatusFillList: data.data,
                        });
                    }
                    if (value == scoringRoundActionId) {
                        this.setState({
                            roundFillList: data.data,
                        });
                    }
                } else {
                    responseError(data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getApplicationData() {
        const { round_id, award_event_profile_id, application_status_id, application_no } = this.state;
        this.setState({ isLoading: true });
        this.props
            .get_admin_application_list_action(round_id, award_event_profile_id, application_status_id, application_no)
            .then((data) => {
                if (data.error !== 1) {
                    this.setState({
                        applicationData: data.data[0],
                        applicationCount: data.data[1][0],
                        isLoading: false,
                        currentpage: 1,
                    });
                } else {
                    this.setState({ isLoading: false });
                    responseError(data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    navigateRoleAdd() {
        this.props.navigate("/roleAU", {
            state: { role_id: 0 },
        });
    }
    navigateApplication(role_id) {
        this.props.navigate(`/roleAU`, {
            state: { role_id: role_id },
        });
    }

    clearFilters() {
        this.setState({
            round_id: "", application_status_id: "", award_event_profile_id: "", application_no: ''
        });
        setTimeout(() => {
            this.getApplicationData();
        }, 100);
    }
    updateItem(item) {
        this.setState({ currentPage: item });
    }
    navigateApplicationView(application_form_id, award_event_profile_id) {
        this.props.navigate('/adminApplicationView', {
            state: {
                application_form_id: application_form_id,
                award_event_profile_id: award_event_profile_id
            }
        })
    }
    handleSort = (key) => {
        this.setState({ currentPage: 1 })
        this.setState((prevState) => {
            const isAscending = prevState.sortKey === key && prevState.sortOrder === "asc";
            const sortedData = [...prevState.applicationData].sort((a, b) => {
                if (key === "created_date") {
                    // Handle date sorting
                    const dateA = a[key] ? new Date(a[key]) : new Date(0);
                    const dateB = b[key] ? new Date(b[key]) : new Date(0);
                    return isAscending ? dateB - dateA : dateA - dateB;
                } else {
                    // Handle string sorting (name, application_no)
                    const valueA = a[key] ? a[key].toString().toLowerCase() : "";
                    const valueB = b[key] ? b[key].toString().toLowerCase() : "";
                    return isAscending ? valueB.localeCompare(valueA) : valueA.localeCompare(valueB);
                }
            });

            return {
                applicationData: sortedData,
                sortKey: key,
                sortOrder: isAscending ? "desc" : "asc",
            };
        });
    };

    applicationRecords(applicationData) {
        const { sortKey, sortOrder } = this.state;

        return (
            <table className="table" id="dashboard-table">
                <thead>
                    <tr>
                        <th style={{ width: "25%", cursor: "pointer" }} onClick={() => this.handleSort("applicant_name")}>
                            Name {(sortOrder === "asc" ? "↑" : "↓")}
                        </th>
                        <th style={{ width: "30%" }}>Email / Contact Details</th>
                        <th style={{ width: "13%" }}>Company</th>
                        <th style={{ width: "10%" }}>Status</th>
                        <th
                            style={{ width: "12%", cursor: "pointer", textAlign: 'center' }}
                            onClick={() => this.handleSort("application_no")}
                        >
                            Application No {(sortOrder === "asc" ? "↑" : "↓")}
                        </th>
                        <th
                            style={{ width: "10%", cursor: "pointer", textAlign: 'center' }}
                            onClick={() => this.handleSort("created_date")}
                        >
                            Date of Application {(sortOrder === "asc" ? "↑" : "↓")}
                        </th>
                        <th className="text-right" style={{ width: "7%" }}>
                            Payment
                        </th>
                    </tr>
                </thead>
                <tbody id="myTable">
                    {applicationData.length > 0 ? (
                        applicationData.map((data) => (
                            <tr key={data.application_form_id}>
                                <td>{data.applicant_name}</td>
                                <td>{data.email_contact_no}</td>
                                <td>{data.company}</td>
                                <td>{data.status_name === "R1 Under Review" ? "Verified" : data.status_name}</td>
                                <td
                                    style={{ color: "#062EC1", cursor: "pointer", textAlign: 'center' }}
                                    onClick={() => this.navigateApplicationView(data.application_form_id, data.award_event_profile_id)}
                                >
                                    {data.application_no}
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    {data.created_date != null ? moment.utc(data.created_date).format("DD-MM-YYYY") : ""}
                                </td>
                                <td className="text-right">
                                    {data.Payment != null ? data.Payment : "Pending"}
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={8} className="text-center">
                                No records found
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
    render() {
        const {
            isLoading, applicationData, currentPage, applicationCount,
            isAccordionExpanded, applicationStatusFillList, roundFillList,
            awardProfileFillList, round_id, round_name, award_event_profile_id,
            award_name, application_status_id, status_name, application_no
        } = this.state;
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        // Records to be displayed on the current page
        const currentRecords = applicationData?.slice(
            indexOfFirstRecord,
            indexOfLastRecord
        );
        const nPages = Math.ceil(applicationData?.length / recordsPerPage);
        const statusCountMapping = {
            Draft: applicationCount.Draft_Count,
            Submitted: applicationCount.Submitted_Count,
            Rejected: applicationCount.Rejected_Count,
            "Verified": applicationCount.Verified_Count,
            "Partial Reviewed": applicationCount.Partial_Reviewed_Count,
            "Reviewed": applicationCount.Reviewed_Count,
            Shortlisted: applicationCount.Nominated_Count,
            "Winner": applicationCount.Result_Declared_Count
        };
        return (
            <>
                {isLoading ? <Loader></Loader> : null}
                <>
                    <main id="main">

                        <div className="website-view">
                            <Header data={[8]} />
                        </div>
                        <div className="mobile-view">
                            <MobileHeader data={[8]} />
                        </div>
                        {/* <Header data={[20]} /> */}
                        <section class='header_margin_top'>
                            <div className="container-fluid">
                                <div
                                    style={customStepperStyles.pageHeader}
                                    className="col-12 d-flex flex-column flex-md-row align-items-center justify-content-between"
                                >
                                    <div style={customStepperStyles.headerContent} className="text-center text-md-left mb-3 mb-md-0">
                                        <div>
                                            <h2 className="mb-3 dashboard-tit py-0 blog-name blog-name-1">Application</h2>
                                            {/* {award_event_profile_id && (
                                                <p style={customStepperStyles.category}>
                                                    <b>
                                                        {award_event_profile_id != null
                                                            ? (() => {
                                                                const awardProfileName = awardProfileFillList.find(
                                                                    (data) => data.award_event_profile_id == award_event_profile_id
                                                                );
                                                                return awardProfileName ? awardProfileName.award_name : '';
                                                            })()
                                                            : null}
                                                    </b>
                                                </p>
                                            )} */}
                                        </div>
                                    </div>
                                    <div
                                        style={customStepperStyles.progressContainer}
                                        className="col-12 col-md-10 d-flex flex-wrap justify-content-center justify-content-md-end"
                                    >
                                        {applicationStatusFillList
                                            .filter((step) => step.status_name !== 'R1 Under Review')
                                            .map((step, index) => (
                                                <div
                                                    className="d-flex flex-column align-items-center mx-1 mb-3"
                                                    style={customStepperStyles.progressStep}
                                                    key={index}
                                                >
                                                    <div
                                                        className="d-flex justify-content-center align-items-center rounded-circle-award"
                                                        style={
                                                            step.status_name === 'Draft'
                                                                ? {
                                                                    background: '#fffdf6',
                                                                    color: '#ffcc00',
                                                                    border: '1px solid #ffcc00',
                                                                }
                                                                : step.status_name === 'Submitted'
                                                                    ? {
                                                                        background: '#effff7',
                                                                        color: '#00cc66',
                                                                        border: '1px solid #00cc66',
                                                                    }
                                                                    : step.status_name === 'Rejected'
                                                                        ? {
                                                                            background: '#fff6f6',
                                                                            color: '#ff0000',
                                                                            border: '1px solid #ff0000',
                                                                        }
                                                                        : step.status_name === 'Verified'
                                                                            ? {
                                                                                background: '#f0fff0',
                                                                                color: '#009900',
                                                                                border: '1px solid #009900',
                                                                            }
                                                                            : step.status_name === 'Partial Reviewed'
                                                                                ? {
                                                                                    background: '#fff7f0',
                                                                                    color: '#bc6c25',
                                                                                    border: '1px solid #bc6c25',
                                                                                }
                                                                                : step.status_name === 'Reviewed'
                                                                                    ? {
                                                                                        background: '#f1fffc',
                                                                                        color: '#00ffcc',
                                                                                        border: '1px solid #00ffcc',
                                                                                    }
                                                                                    : step.status_name === 'Shortlisted'
                                                                                        ? {
                                                                                            background: '#f4fbff',
                                                                                            color: '#0099ff',
                                                                                            border: '1px solid #0099ff',
                                                                                        }
                                                                                        : step.status_name === 'Winner'
                                                                                            ? {
                                                                                                background: '#f7f7ff',
                                                                                                color: '#6666ff',
                                                                                                border: '1px solid #6666ff',
                                                                                            }
                                                                                            : {}
                                                        }
                                                        onClick={() =>
                                                            this.setState(
                                                                {
                                                                    application_status_id: step.application_status_id,
                                                                    status_name: step.status_name,
                                                                    award_name: '',
                                                                    award_event_profile_id: '',
                                                                },
                                                                () => this.getApplicationData()
                                                            )
                                                        }
                                                    >
                                                        {statusCountMapping[step.status_name] > 0 ? statusCountMapping[step.status_name] : 0}
                                                    </div>
                                                    <p
                                                        className="mb-0 circle-award-name text-center"
                                                        style={{
                                                            ...customStepperStyles.progressStepText,
                                                            ...(step.status_name === 'Draft'
                                                                ? { color: '#ffcc00' }
                                                                : step.status_name === 'Submitted'
                                                                    ? { color: '#00cc66' }
                                                                    : step.status_name === 'Rejected'
                                                                        ? { color: '#ff0000' }
                                                                        : step.status_name === 'Verified'
                                                                            ? { color: '#009900' }
                                                                            : step.status_name === 'Partial Reviewed'
                                                                                ? { color: '#bc6c25' }
                                                                                : step.status_name === 'Reviewed'
                                                                                    ? { color: '#00ffcc' }
                                                                                    : step.status_name === 'Shortlisted'
                                                                                        ? { color: '#0099ff' }
                                                                                        : step.status_name === 'Winner'
                                                                                            ? { color: '#6666ff' }
                                                                                            : { color: 'black' }),
                                                        }}
                                                    >
                                                        {step.status_name}
                                                    </p>
                                                    {index < applicationStatusFillList.length - 1 && (
                                                        <div className="mx-2" style={customStepperStyles.progressLine}></div>
                                                    )}
                                                </div>
                                            ))}
                                    </div>
                                </div>

                                <div className="search_accordion">
                                    <div className="panel-group" id="accordion">
                                        <div className="panel panel-default">
                                            <div
                                                className="panel-heading accordion-toggle collapsed p-2"
                                                data-toggle="collapse"
                                                data-parent="#accordion"
                                                data-target="#collapseOne"
                                                aria-expanded={isAccordionExpanded}
                                                onClick={() =>
                                                    this.setState({
                                                        isAccordionExpanded: !isAccordionExpanded,
                                                    })
                                                }
                                            >
                                                <h4 className="panel-title">Search</h4>
                                                <div className="searched_items">
                                                    {application_no ? <><h5><b> Application No :</b> <span>{application_no != "" ? application_no : null}</span></h5></> : <></>}
                                                    {round_id ? <><h5><b> Round :</b> <span>{round_id != "" ? round_name : null}</span></h5></> : <></>}
                                                    {award_event_profile_id ? <h5><b> Category :</b> <span>{award_event_profile_id != "" ? award_name : null}</span></h5> : <></>}
                                                    {application_status_id ? <h5><b> Status :</b> <span>{application_status_id != "" ? status_name : null}</span></h5> : <></>}
                                                </div>
                                            </div>
                                            <div
                                                id="collapseOne"
                                                className={`panel-collapse collapse ${isAccordionExpanded ? "show" : ""
                                                    }`}
                                            >
                                                <div className="panel-body pt-0 p-2">
                                                    <div className="row mr_0">
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label>Application No</label>
                                                                <input type="text" className="form-control" value={application_no} onChange={(e) => this.setState({ application_no: e.target.value })} />
                                                            </div></div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label>Round</label>
                                                                <select
                                                                    className="form-select"
                                                                    value={round_id}
                                                                    onChange={(e) => {
                                                                        const selectedRound = roundFillList.find((item) => item.round_id === parseInt(e.target.value, 10));
                                                                        this.setState({
                                                                            round_id: selectedRound?.round_id,
                                                                            round_name: selectedRound?.round_name,
                                                                        })
                                                                    }}>
                                                                    <option value="">Select</option>
                                                                    {roundFillList.length > 0 &&
                                                                        roundFillList.map((item) => (
                                                                            <option key={item.round_id} value={item.round_id}>
                                                                                {item.round_name}
                                                                            </option>
                                                                        ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label>Category</label>
                                                                <select
                                                                    className="form-select"
                                                                    value={award_event_profile_id}
                                                                    onChange={(e) => {
                                                                        const selectedCategory = awardProfileFillList.find(
                                                                            (item) => item.award_event_profile_id === parseInt(e.target.value, 10)
                                                                        );
                                                                        this.setState({
                                                                            award_event_profile_id: selectedCategory?.award_event_profile_id,
                                                                            award_name: selectedCategory?.award_name,
                                                                        });
                                                                    }}
                                                                >
                                                                    <option value="">Select</option>
                                                                    {awardProfileFillList.length > 0 &&
                                                                        awardProfileFillList.filter(data => (data.publish_status == 1 || data.publish_status == true)).map((item) => (
                                                                            <option key={item.award_event_profile_id} value={item.award_event_profile_id}>
                                                                                {item.award_name}
                                                                            </option>
                                                                        ))}
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label>Status</label>
                                                                <select
                                                                    className="form-select"
                                                                    value={application_status_id}
                                                                    onChange={(e) => {
                                                                        const selectedStatus = applicationStatusFillList.find(
                                                                            (item) => item.application_status_id === parseInt(e.target.value, 10)
                                                                        );
                                                                        this.setState({
                                                                            application_status_id: selectedStatus?.application_status_id,
                                                                            status_name: selectedStatus?.status_name,
                                                                        });
                                                                    }}
                                                                >
                                                                    <option value="">Select</option>
                                                                    {applicationStatusFillList.length > 0 &&
                                                                        applicationStatusFillList.map((item) => (
                                                                            <option key={item.application_status_id} value={item.application_status_id}>
                                                                                {item.status_name}
                                                                            </option>
                                                                        ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label>&nbsp;</label>
                                                            <button
                                                                onClick={() => this.getApplicationData()}
                                                                className="btn btn-outline-primary search_btn w-auto p-1 mr-2"
                                                            >
                                                                Search
                                                            </button>
                                                            &nbsp;
                                                            <button
                                                                onClick={this.clearFilters}
                                                                className="btn btn-outline-danger search_btn w-auto p-1 "
                                                            >
                                                                Clear Filters
                                                            </button>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="custom_table">
                                    <div className="hack1">
                                        <div className="hack2">
                                            {this.applicationRecords(currentRecords)}
                                            {applicationData.length > 0 ? (
                                                <Pagination
                                                    nPages={nPages}
                                                    currentPage={currentPage}
                                                    setCurrentPage={this.updateItem}
                                                />
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>

                    <Footer />
                    <ToastContainer />
                </>
            </>
        );
    }
}
export default withRouter(
    connect(null, { get_admin_application_list_action, fill_action })(AdminApplicationList)
);
